// src/pages/Courses.js
import React from 'react';
import { Typography, List, ListItem, ListItemText, Paper } from '@mui/material';

const Courses = () => {
  // Sample data; replace with real data
  const courses = [
    { id: 1, name: 'Mathematics 101' },
    { id: 2, name: 'Physics 201' },
    { id: 3, name: 'Chemistry 301' },
  ];

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Enrolled Courses
      </Typography>
      <List>
        {courses.map((course) => (
          <ListItem key={course.id}>
            <ListItemText primary={course.name} />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default Courses;
